export function getActiveLinkIdentifier(url) {
  const urlArray = url.split("/");
  return urlArray[3] || "";
}
